// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".var-row[data-v-59b721da]{display:grid;grid-template-columns:1fr 1fr 1fr 1fr 100px;grid-column-gap:20px;margin-bottom:20px;align-items:center}.var-row .single-value[data-v-59b721da]{grid-column:span 2}.var-row .labeled-select[data-v-59b721da]{min-height:61px}.var-row .remove BUTTON[data-v-59b721da]{padding:0}", ""]);
// Exports
module.exports = exports;
